import {HISTORY_SUCCESS, HISTORY_CLEAR} from "../constants";


export function  history (state=[], action) {

    switch(action.type){
        case HISTORY_SUCCESS:
            return action.payload
        case HISTORY_CLEAR:
            return state = []
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/history.js